import { Controller } from "stimulus"

export default class extends Controller {
  showNameEdit() {
    var editArea = document.getElementById("inlineNameEdit")
    if (editArea) {
      editArea.classList.remove("hidden")
    }
  }

  hideNameEdit() {
    var editArea = document.getElementById("inlineNameEdit")
    if (editArea) {
      editArea.classList.add("hidden")
    }
  }
}
